import ApiService from '@/core/services/ApiService';

export interface UnreadSnapshot { unread_count: number; latest_alarm_user_id: number | null }
const key = (userId: number) => `partner-notifications-unread:${userId}`;
export const cachedUnreadCount = (userId: number): number => {
  const value = Number(localStorage.getItem(key(userId)));
  return Number.isFinite(value) && value > 0 ? value : 0;
};
export const cacheUnreadCount = (userId: number, count: number): void => {
  localStorage.setItem(key(userId), String(Math.max(0, count || 0)));
};
export const clearCachedUnreadCount = (userId?: number): void => {
  if (userId) localStorage.removeItem(key(userId));
};
export const fetchUnreadSnapshot = async (): Promise<UnreadSnapshot> => {
  const {data} = await ApiService.get('/notifications', 'unread');
  return data;
};
export const markUnreadSnapshotRead = async (throughId: number | null): Promise<UnreadSnapshot> => {
  const {data} = await ApiService.post('/notifications/read', {through_id: throughId});
  return data;
};
